import { render } from "./SidebarLanding.vue?vue&type=template&id=d7bef672"
import script from "./SidebarLanding.vue?vue&type=script&lang=js"
export * from "./SidebarLanding.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/frontend-dilatih/frontend-dilatih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__